import React from 'react';
import { DIMENSION_NAMES, DEFAULT_INSIGHT_MESSAGES } from '../../utils/constants';

export default function PerspectiveShiftScreen({ dimensionId, onContinue }) {
  const dimensionName = DIMENSION_NAMES[dimensionId] || dimensionId;
  const defaultMessage = DEFAULT_INSIGHT_MESSAGES[dimensionId] || '';

  return (
    <div
      className="view on"
      data-testid="perspective-shift-screen"
      style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}
    >
      <div
        className="label"
        style={{ color: 'var(--amber)', marginBottom: '8px' }}
        data-content="_misc.perspective_shift_label"
      >
        PERSPECTIVE SHIFT
      </div>
      <h2 data-content={`_misc.insight_title_${dimensionId}`}>
        Perspective on {dimensionName}
      </h2>
      <p className="dim" data-content={`_misc.insight_${dimensionId}`}>{defaultMessage}</p>
      <button
        className="btn btn-p"
        onClick={onContinue}
        data-testid="continue-journey-btn"
      >
        <span data-content="_misc.perspective_shift_cta">Continue Journey</span>
      </button>
    </div>
  );
}
